/**
 * @brief   アラート対象項目
 */
export enum AlertTargetItem {
    None = 0x00,
    Windows = 0x01,
    Mac = 0x02,

    All = Windows | Mac
}